function FormInput({
  input,
  handleInputChange,
  value,
  hasAddButton = false,
  errorMessage,
  handleAddInput = () => {},
}) {
  if (hasAddButton) {
    return (
      <div className="form__item" data-test="form-input-submit-question">
        <label htmlFor={input.name}>{input.label}</label>
        <div className="form__item__input__container">
          <textarea
            id={input.id}
            name={input.name}
            className="form-control form__item__input"
            type={input.type}
            placeholder={input.placeholder}
            value={value}
            onChange={handleInputChange}
            rows={1}
            data-test={input.id.replaceAll(' ', '-').toLowerCase()}
          />
          <button
            className="btn btn-primary btn-add"
            type="button"
            onClick={handleAddInput}
            data-test="add-incorrect-answer-button"
          >
            +
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="form__item">
        <label htmlFor={input.name}>{input.label}</label>
        <textarea
          id={input.id}
          name={input.name}
          className="form-control form__item__input"
          type={input.type}
          placeholder={input.placeholder}
          value={value}
          onChange={handleInputChange}
          rows={1}
          data-test={input.id.replaceAll(' ', '-').toLowerCase()}
        />
      </div>
      {errorMessage ? (
        <div className="form__item__error-message">{errorMessage}</div>
      ) : null}
    </>
  );
}

export default FormInput;
